import { GridRowModes, GridToolbarContainer, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid-premium';
import { Field, FieldArray, useFormikContext } from 'formik';
import { v4 as uuidv4 } from 'uuid';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';

import { dataGridPremiumColumns } from '../../utils/helper';

import { DataGridIdentifiers, FormErrorUI, AutoCompleteSelectUI, AddButtonUi, DatagridPremiumUi } from '../Interface';

function EditToolbar(props) {
  const { disabled, push, defTaskListRespPerson } = props;
  const { values, validateField } = useFormikContext();

  const handleClick = async () => {
    const newData = {
      ...defTaskListRespPerson,
      id: uuidv4(),
    };

    await push(newData);

    const fieldsToValidate = [`taskListRespPerson.${values.taskListRespPerson.length ?? 0}.userId`];

    for (const field of fieldsToValidate) {
      await validateField(field);
    }
  };

  return (
    <GridToolbarContainer>
      <AddButtonUi disabled={disabled} onClick={handleClick} />
    </GridToolbarContainer>
  );
}

const TaskListRespPersonTable = ({ disabled, defTaskListRespPerson, autoCompleteOptions }) => {
  const apiRef = useGridApiRef();
  const { values, validateField, setFieldValue, errors } = useFormikContext();

  const getValueIndex = (values, id) => {
    return values.taskListRespPerson.findIndex((rc) => rc.id === id);
  };

  const columns = (setFieldValue, validateField, errors, remove) => {
    return dataGridPremiumColumns([
      {
        field: 'userId',
        headerName: 'Felelős',
        type: 'string',
        editable: true,
        renderCell: (data) => {
          const findedUser = autoCompleteOptions?.user.find((item) => item.value === data.row?.userId);
          return findedUser?.label;
        },
        renderEditCell: (data) => {
          const valueIndex = getValueIndex(values, data.id);
          const findedUser = autoCompleteOptions.user.find((item) => item.value === data.row.userId);

          return (
            <Field
              name={`taskListRespPerson.${valueIndex}.userId`}
              component={AutoCompleteSelectUI}
              helperText={<FormErrorUI message={errors?.taskListRespPerson?.[valueIndex]?.userId} />}
              selectedValue={values.taskListRespPerson?.[valueIndex]?.userId}
              selectedLabelValue={findedUser?.label}
              onChange={(_e, newVal) => {
                setFieldValue(`taskListRespPerson.${valueIndex}.userId`, newVal?.value ?? null);
                data.api.setEditCellValue({
                  id: data.id,
                  field: data.field,
                  value: newVal.value ?? null,
                });
              }}
              dataset={autoCompleteOptions.user}
              onBlur={async () => await validateField(`taskListRespPerson.${valueIndex}.userId`)}
            />
          );
        },
      },
      {
        field: 'actions',
        type: 'actions',
        headerName: 'Szerk.',
        cellClassName: 'actions',
        sortable: false,
        getActions: ({ id }) => {
          return [
            <GridActionsCellItem
              icon={<DeleteIcon />}
              label="Delete"
              onClick={() => {
                const valueIndex = getValueIndex(values, id);
                return remove(valueIndex);
              }}
              color="inherit"
              disabled={disabled}
            />,
          ];
        },
      },
    ]);
  };

  return (
    <div className="overflow-x-auto">
      <div className="align-middle">
        <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
          <FieldArray name="taskListRespPerson">
            {({ remove, push }) => (
              <DatagridPremiumUi
                apiRef={apiRef}
                datagridIdentifier={DataGridIdentifiers.TaskListRespPersonTable}
                height={400}
                columns={columns(setFieldValue, validateField, errors, remove)}
                rows={values?.taskListRespPerson ?? []}
                slots={{
                  toolbar: EditToolbar,
                }}
                headerFilters={false}
                slotProps={{
                  toolbar: {
                    disabled,
                    push,
                    defTaskListRespPerson,
                  },
                }}
                onCellDoubleClick={(_params, event) => {
                  event.defaultMuiPrevented = true;
                }}
                editMode="row"
                getRowHeight={() => 'auto'}
                onCellClick={(params, event) => {
                  if (disabled) return;
                  const rowMode = apiRef.current.getRowMode(params.row.id);
                  if (rowMode === GridRowModes.View) apiRef.current.startRowEditMode({ id: params.row.id });
                }}
              />
            )}
          </FieldArray>
        </div>
      </div>
    </div>
  );
};

export default TaskListRespPersonTable;
